module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch01#ch01"
    }
  }, [_vm._v("Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch02#ch02"
    }
  }, [_vm._v("The Usual Gang of Idiots")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Discipline Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Happened to God")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where the Wild Things Are")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Priest with a Girlfriend")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Did You Think I Was Tame?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southern Gothic")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Precipitation and Anchovies")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shopping on a Budget")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rebels of the Blessed Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pets")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food Chain")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Test of the Emergency Broadcast System")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Welcome to Horrible Movies")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Another Color")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bwana Tim")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banshee in the Woods")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Underground")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not Approved by the Comics Code Authority")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d989bae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/content.vue
// module id = 72
// module chunks = 0